// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vec-alert__Alert-module--mG0Dk {
    border: none !important;
}

.vec-alert__Alert-module--mG0Dk.ant-alert-with-description .ant-alert-title {
    font-weight: 600 !important;
}
`, "",{"version":3,"sources":["webpack://./vector/src/Alert/Alert.module.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":[".vec-alert {\n    border: none !important;\n}\n\n.vec-alert:global(.ant-alert-with-description) :global(.ant-alert-title) {\n    font-weight: 600 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"vecAlert": `vec-alert__Alert-module--mG0Dk`
};
export default ___CSS_LOADER_EXPORT___;
